import { createActions, createReducer } from 'reduxsauce';
import { ISliderTitleProps } from 'components/Slider/interface';

export const { Types, Creators } = createActions({
  hideTitle: ['data'],
  showTitle: ['data'],
});

const INITIAL_STATE: ISliderTitleProps = {
  hide: false
};

const showTitle = (state = INITIAL_STATE, action: any) => ({
  ...action.data, 
  hide: false,
});

const hideTitle = (state = INITIAL_STATE, action: any) => ({
  ...action.data, 
  hide: true,
});

export default createReducer(INITIAL_STATE, {
  [Types.HIDE_TITLE as any]: hideTitle,
  [Types.SHOW_TITLE as any]: showTitle,
});